// @ts-check

/**
 * -----------------------------------------------
 * Page requesting data events
 * -----------------------------------------------
 */
export const REFERRAL_DASHBOARD_PAGE_MOUNTED = 'REFERRAL_DASHBOARD_PAGE_MOUNTED';
export const REFERRAL_DASHBOARD_NEXT_PAGE_REQUESTED = 'REFERRAL_DASHBOARD_NEXT_PAGE_REQUESTED';
export const REFERRAL_DASHBOARD_SEARCH_SUBMITTED = 'REFERRAL_DASHBOARD_SEARCH_SUBMITTED';

export function referralDashboardPageMounted(referralProfileId, networkId) {
  return {
    type: REFERRAL_DASHBOARD_PAGE_MOUNTED,
    referralProfileId,
    networkId,
  };
}

export function referralDashboardNextPageRequested(referralProfileId, networkId) {
  return {
    type: REFERRAL_DASHBOARD_NEXT_PAGE_REQUESTED,
    referralProfileId,
    networkId,
  };
}

export function referralDashboardSearchSubmitted(
  referralProfileId,
  searchTerm,
  specialtyId,
  range,
  ageClassification,
  networkId
) {
  return {
    type: REFERRAL_DASHBOARD_SEARCH_SUBMITTED,
    referralProfileId,
    searchTerm,
    specialtyId,
    range,
    ageClassification,
    networkId,
  };
}

/**
 * -----------------------------------------------
 * Page data fetching lifecycle events
 * -----------------------------------------------
 */
export const REFERRAL_DASHBOARD_RESULTS_FETCHING = 'REFERRAL_DASHBOARD_RESULTS_FETCHING';
export const REFERRAL_DASHBOARD_RESULTS_FETCH_FAILED = 'REFERRAL_DASHBOARD_RESULTS_FETCH_FAILED';
export const REFERRAL_DASHBOARD_RESULTS_FETCH_CANCELLED =
  'REFERRAL_DASHBOARD_RESULTS_FETCH_CANCELLED';
export const REFERRAL_DASHBOARD_RESULTS_RECEIVED = 'REFERRAL_DASHBOARD_RESULTS_RECEIVED';

/**
 * @param {number?} page
 * @param {string?} searchTerm
 */
export function referralDashboardResultsFetching(page = 1, searchTerm = '') {
  return {
    type: REFERRAL_DASHBOARD_RESULTS_FETCHING,
    page,
    searchTerm,
  };
}

export function referralDashboardResultsFetchFailed(error) {
  return {
    type: REFERRAL_DASHBOARD_RESULTS_FETCH_FAILED,
    error,
  };
}

export function referralDashboardResultsFetchCancelled() {
  return { type: REFERRAL_DASHBOARD_RESULTS_FETCH_CANCELLED };
}

/**
 * @param {string} referralProfileId
 * @param {any} entities
 * @param {number} page
 * @param {number} totalPages
 * @param {string} searchTerm
 * @param {string} specialtyId
 * @param {string} range
 * @param {"adult" | "pediatric"} ageClassification
 * @param {string} receivedAt
 */
export function referralDashboardResultsReceived(
  referralProfileId,
  entities,
  page,
  totalPages,
  searchTerm,
  range,
  specialtyId,
  ageClassification,
  receivedAt,
  network,
  organizationReferralRejected
) {
  const matchingResultIds = entities.referralProfiles[referralProfileId].matchingResults;
  return {
    type: REFERRAL_DASHBOARD_RESULTS_RECEIVED,
    referralProfile: referralProfileId,
    matchingResultIds,
    entities,
    page,
    totalPages,
    searchTerm,
    specialtyId,
    range,
    ageClassification,
    receivedAt,
    network,
    organizationReferralRejected
  };
}

/**
 * -----------------------------------------------
 * Slot sets requesting events
 * -----------------------------------------------
 */
export const REFERRAL_DASHBOARD_NEXT_PAGE_SLOTS_REQUESTED =
  'REFERRAL_DASHBOARD_NEXT_PAGE_SLOTS_REQUESTED';
export const REFERRAL_DASHBOARD_PREVIOUS_PAGE_SLOTS_REQUESTED =
  'REFERRAL_DASHBOARD_PREVIOUS_PAGE_SLOTS_REQUESTED';
export const REFERRAL_DASHBOARD_PAGE_SLOTS_FETCHING = 'REFERRAL_DASHBOARD_PAGE_SLOTS_FETCHING';
export const REFERRAL_DASHBOARD_PAGE_SLOTS_RECEIVED = 'REFERRAL_DASHBOARD_PAGE_SLOTS_RECEIVED';

/**
 * @param {string} referralProfileId
 * @param {string} resultId
 */
export function referralDashboardNextPageSlotsRequested(referralProfileId, resultId) {
  return {
    type: REFERRAL_DASHBOARD_NEXT_PAGE_SLOTS_REQUESTED,
    referralProfileId,
    resultId,
  };
}

/**
 * @param {string} referralProfileId
 * @param {string} resultId
 */
export function referralDashboardPreviousPageSlotsRequested(referralProfileId, resultId) {
  return {
    type: REFERRAL_DASHBOARD_PREVIOUS_PAGE_SLOTS_REQUESTED,
    referralProfileId,
    resultId,
  };
}

/**
 * @param {string} resultId
 */
export function referralDashboardPageSlotsFetching(resultId) {
  return {
    type: REFERRAL_DASHBOARD_PAGE_SLOTS_FETCHING,
    resultId,
  };
}

export function referralDashboardPageSlotsReceived(resultId, slots, receivedAt) {
  return {
    type: REFERRAL_DASHBOARD_PAGE_SLOTS_RECEIVED,
    resultId,
    slots,
    receivedAt,
  };
}

/**
 * -----------------------------------------------
 * Out of group reason events
 * -----------------------------------------------
 */
export const REFERRAL_DASHBOARD_OUT_OF_GROUP_REASON_REQUIRED =
  'REFERRAL_DASHBOARD_OUT_OF_GROUP_REASON_REQUIRED';
export const REFERRAL_DASHBOARD_OUT_OF_GROUP_REASON_PROVIDED =
  'REFERRAL_DASHBOARD_OUT_OF_GROUP_REASON_PROVIDED';

/**
 * @param {(reason: string) => any} onReasonProvided
 */
export function outOfGroupReasonRequired(onReasonProvided) {
  return {
    type: REFERRAL_DASHBOARD_OUT_OF_GROUP_REASON_REQUIRED,
    onReasonProvided,
  };
}

/**
 * @param {string} reason
 */
export function outOfGroupReasonProvided(reason) {
  return {
    type: REFERRAL_DASHBOARD_OUT_OF_GROUP_REASON_PROVIDED,
    reason,
  };
}
